export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-speed-up-line',
      iconBg: 'bg-primary-100',
      iconColor: 'text-primary-500',
      title: '极速更新',
      desc: '7×24小时不间断追踪，重大爆料发生后5分钟内上线，确保你永远比朋友圈先知道。',
    },
    {
      icon: 'ri-verified-badge-line',
      iconBg: 'bg-accent-100',
      iconColor: 'text-accent-500',
      title: '严选内容',
      desc: '每一条资讯均由资深编辑团队双重审核，去伪存真，拒绝谣言与标题党。',
    },
    {
      icon: 'ri-group-line',
      iconBg: 'bg-secondary-100',
      iconColor: 'text-secondary-500',
      title: '瓜友社区',
      desc: '百万活跃用户每日互动讨论，热评、投票、话题圈，吃瓜不再是一个人的孤独。',
    },
  ];

  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          为什么选我们
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-background-50 rounded-xl p-6 md:p-8 text-center group cursor-pointer transition-all hover:-translate-y-1">
              <div className={`w-14 h-14 mx-auto mb-4 rounded-2xl ${f.iconBg} flex items-center justify-center`}>
                <i className={`${f.icon} text-2xl ${f.iconColor}`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-950 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}